import { useState } from "react";
import { ConfirmHolidayModal } from "./confirmHolidayModal";
import { AddHolidayModal } from "./addHolidayModal";
import { BaseApiErrorResponse } from "../../../utils/types";
import { useAddHolidayMutation } from "../../../redux/features/admin/admin.api";

export const AddHolidayFlow = ({
  open,
  handleClose,
  onSuccess,
  refetchHolidays,
}: {
  open: boolean;
  handleClose: () => void;
  onSuccess: () => void;
  refetchHolidays: () => void;
}) => {
  const [step, setStep] = useState(1);
  const [holidayData, setHolidayData] = useState({
    name: "",
    holidayDate: "",
    nextWorkingDay: "",
  });

  const [addHoliday, { isLoading: addingHoliday, error, isError }] =
    useAddHolidayMutation();

  const handleFormSubmit = (data: {
    name: string;
    holidayDate: string;
    nextWorkingDay: string;
  }) => {
    setHolidayData(data);
    setStep(2);
  };

  const handleConfirmSubmit = async () => {
    const resp = await addHoliday(holidayData);
    if (resp?.data?.status === "success") {
      onSuccess();
      refetchHolidays();
      handleClose();
      setStep(1);
    }
  };

  return (
    <>
      {step === 1 && (
        <AddHolidayModal
          open={open}
          handleClose={handleClose}
          onSuccess={() => {}}
          onContinue={handleFormSubmit}
          initialValues={holidayData}
        />
      )}
      {step === 2 && (
        <ConfirmHolidayModal
          open={open}
          handleBack={() => setStep(1)}
          handleClose={handleClose}
          handleAddHoliday={handleConfirmSubmit}
          addingHoliday={addingHoliday}
          error={error as BaseApiErrorResponse}
          isError={isError}
          {...holidayData}
        />
      )}
    </>
  );
};
